import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class RecentItemsService {
   public recentItemsRefreshSignal = signal(0);

  get recentItemsRefresh() {
    return this.recentItemsRefreshSignal;
  }

  refreshRecentItems() {
    console.log("Refreshing recent items...");
    this.recentItemsRefreshSignal.set(this.recentItemsRefreshSignal() + 1);
  }
} 